import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

ReactDOM.render(
  <React.StrictMode>
    <h1 className='text-center text-primary'>Appointment Scheduler</h1>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)
